<template>
	<div class="px-4 pt-5">
		<section class="px-4">
			<form>
				<v-text-field
					solo
					hide-details
					class="mb-4"
					placeholder="Agregue el código"
					name="code"
					v-model="$v.globalRole.code.$model"
				></v-text-field>
				<v-text-field
					solo
					hide-details
					class="mb-2"
					label="Nombre"
					placeholder="Agregue el nombre"
					name="name"
					v-model="$v.globalRole.name.$model"
				></v-text-field>
			</form>
		</section>
		<hr class="my-4">
		<section class="px-4">
			<h3 class="mb-3">Configuración</h3>
			<form @submit.prevent="addNewSetting" class="form-style">
				<v-text-field
					solo
					hide-details
					label="Nombre"
					class="mb-2"
					name="setting-name"
					placeholder="Nombre"
					v-model="$v.newSetting.name.$model"
				></v-text-field>
				<v-text-field
					solo
					hide-details
					class="mb-2 mx-2"
					label="Descripción"
					name="setting-description"
					placeholder="Descripción"
					v-model="$v.newSetting.description.$model"
				></v-text-field>
				<v-btn dark color="cyan" class="add-button">
					<v-icon dark>add</v-icon>
				</v-btn>
			</form>
		</section>
		<section>
			<app-table
				class="my-5 is-not-selectable pb-4"
				name="global-roles"
				:columns="columns"
				:rows="globalRole.settings"
			>
				<template slot="rows" slot-scope="props">
					<td
						class="is-not-selectable"
					>
						{{ props.row.name }}
					</td>
					<td>
						{{ props.row.description }}
					</td>
					<td>
						<app-tooltip-button
							color="green"
							icon="edit"
							text="Editar Rol"
							@click-icon="edit(props.row, props.index)"
						/>
						<app-tooltip-button
							color="error"
							icon="delete"
							text="Eliminar Rol"
							@click-icon="deleteRoleSetting(props.row, props.index)"
						/>
					</td>
				</template>
			</app-table>
		</section>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="$v.$invalid"
				@accept-button-clicked="save"
				@cancel-button-clicked="$emit('close-modal')"
			>
			</modal-sidebar-button>
		</section>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';

function addNewSetting() {
	if (this.flagEdit) {
		this.$set(this.globalRole.settings, this.index, this.newSetting);
		this.flagEdit = false;
		this.index = null;
	} else {
		const currentSettings = [...this.globalRole.settings];
		this.globalRole.settings = [].concat(this.newSetting, currentSettings);
	}
	this.clearNewSetting();
}

function clearNewSetting() {
	this.newSetting = {
		name: '',
		description: '',
	};
}

function edit(setting, index) {
	this.flagEdit = true;
	this.newSetting = { ...setting };
	this.index = index;
}

function deleteRoleSetting(setting, index) {
	this.globalRole.settings.splice(index, 1);
}

function save() {}

function validations() {
	return {
		globalRole: {
			code: { required },
			name: { required },
		},
		newSetting: {
			name: { required },
			description: { required },
		},
	};
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', checked: true, visible: true },
			{ id: 2, name: 'Descripción', checked: true, visible: true },
			{ id: 3, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		flagEdit: false,
		globalRole: {
			code: '',
			name: '',
			settings: [],
		},
		index: null,
		newSetting: {
			name: '',
			description: '',
		},
	};
}
export default {
	name: 'new-global-role',
	data,
	methods: {
		addNewSetting,
		clearNewSetting,
		deleteRoleSetting,
		edit,
		save,
	},
	validations,
};
</script>
<style lang="scss" scoped>
	.form-style {
		align-items: end;
		display: flex;
		justify-content: space-between;
	};
</style>


// WEBPACK FOOTER //
// src/components/roles/new-global-role.vue